export const TOOLBAR_DIALOG_ERROR__CONSTS = {
  textDialogError: 'Во время генерации произошла ошибка',
  textAbortError: 'Вы отменили запрос'
}
